import { Env } from "@/env";
import { LoginForm } from "@/components/login-form";
import { useUser } from "@features/user/use-user";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { ReviewsCarousel } from "./components/login-testimonials";

const useEffectPlease = (effect: any, deps: any[]) => {
  (useEffect as any)(effect, deps);
};

export default function SignInPage() {
  const { login } = useUser();
  const urlParams = new URLSearchParams(window.location.search);
  const targetApp = urlParams.get("login-to-app"); // Your custom query param
  const utmSource = urlParams.get("utm_source") || ""; // Get UTM source
  const isFromUpload = urlParams.get("upload") === "1"; // Coming from upload flow

  // Include UTM params in the redirect URL
  const redirectParams = new URLSearchParams();
  if (targetApp) redirectParams.append("login-to-app", "1");
  if (utmSource) redirectParams.append("utm_source", utmSource);

  const redirectUrl = `${window.location.origin}${
    redirectParams.toString() ? `?${redirectParams.toString()}` : ""
  }`;

  useEffectPlease(() => {
    const redirectFlow = async () => {
      const useRedirect = urlParams.get("redirect"); // Your custom query param

      if (useRedirect) {
        const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${
          Env.googleoauth
        }&redirect_uri=${encodeURIComponent(
          redirectUrl
        )}&response_type=token&scope=email profile`;

        window.location.href = googleAuthUrl;
      }

      // if access_token in URL, login with token (in hash #access_token)
      const hash = window.location.hash;
      const token = hash.split("access_token=")?.[1]?.split("&")?.[0];
      if (token) {
        login("google", "redirect:" + token, {
          utm_source: utmSource,
        });
      }
    };

    redirectFlow();
  }, []);

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-white to-gray-100 dark:from-black dark:to-gray-900 text-black dark:text-white">
      {/* Left half - Login form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center relative">
        <div className="p-8 md:p-12 w-full max-w-md z-10">
          <motion.div
            className="flex flex-col items-center space-y-8 text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <LoginForm isFromUpload={isFromUpload} />
          </motion.div>
        </div>
      </div>

      {/* Right half - Reviews carousel */}
      <motion.div
        className="hidden lg:block w-1/2 relative overflow-hidden bg-gradient-to-br from-gray-900 to-black"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.7, delay: 0.5 }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40"
          style={{
            backgroundImage: 'url("/backgrounds/hero_background.png")',
          }}
        ></div>
        <div className="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>
        <ReviewsCarousel />
      </motion.div>
    </div>
  );
}
